// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttonGeneric {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 17px;
  padding: 15px;
  cursor: pointer;
  min-width: 100px auto;
  justify-content: center;
}

.buttonGenericCustom {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 17px;
  padding: 10px 20px;
  cursor: pointer;
  width: 120px;
  height: 50px;
  border: solid 1px #007bc0;
}

.buttonCustom {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 17px;
  padding: 10px 20px;
  cursor: pointer;
  height: 50px;
  border: solid 1px #007bc0;
  width: 100%;
}

.buttonCustom:hover {
  background-color: #d1e4ff;
  border: solid 1px #00629a;
}

.buttonGenericCustom span {
  width: 100%;
}

.buttonFinish {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 17px;
  padding: 15px 30px;
  cursor: pointer;
  margin-top: 20px;
  background-color: #007bc0;
  color: #ffffff;
}

.buttonFinish:hover {
  background-color: #00629a;
}

.buttonFinish img {
  margin-right: 10px;
}

.buttonReload {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 17px;
  padding: 15px 30px;
  cursor: pointer;
  margin-top: 20px;
  border: 1px solid #007bc0;
}

.buttonReload img {
  margin-right: 10px;
}

.buttonReload:hover {
  background-color: #dde5f0;
}

.buttonGeneric:disabled {
  cursor: not-allowed;
  background-color: #979ea4;
}

.imgIcone {
  margin-right: 15px;
}

.buttonGeneric:disabled:hover {
  background-color: #979ea4;
}

.buttonGeneric:hover {
  background-color: #dde5f0;
}

.buttonGoOut {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 17px;
  padding: 15px;
  cursor: pointer;
  width: 175px;
  justify-content: center;
  margin-bottom: 20px;
  background-color: #007bc0;
  color: #ffffff;
}

.buttonGoOut:hover {
  background-color: #00629a;
}

.buttonGoOut:disabled {
  cursor: not-allowed;
  background-color: #d9d9d9;
  color: #898989;
}

button.buttonGeneric.buttonHover:hover {
  background: #00629a;
}

.buttonGenericCustom:hover {
  background-color: #d1e4ff;
}

.buttonHeading {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 16px;
  padding: 13px 15px;
  cursor: pointer;
  background-color: #007bc0;
}

.buttonHeading img {
  padding-right: 6px;
  width: 18px;
  height: 18px;
}

.buttonHeading:hover {
  background-color: #00629a;
}

.buttonBack {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 16px;
  padding: 12px 15px;
  cursor: pointer;
  background-color: #fff;
  border: 1px solid #007bc0;
}

.buttonBack img {
  width: 11px;
}

.buttonBack:hover {
  background-color: #d1e4ff;
}

.buttonDownload {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 16px;
  padding: 13px 15px;
  cursor: pointer;
  background-color: #f9f9f9;
}

.buttonDownload:hover {
  background-color: #d1e4ff;
}

.css-1v70q85-MuiDataGrid-root .MuiDataGrid-footerContainer {
  background: #f9f9f9;
}

.css-1v70q85-MuiDataGrid-root {
  border-width: 0px !important;
  border-style: none !important;
  border-color: transparent !important;
  border-radius: 0px !important;
}
`, "",{"version":3,"sources":["webpack://./src/componentes/ButtonGeneric/buttonGeneric.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,oCAAoC;EACpC,6BAA6B;AAC/B","sourcesContent":[".buttonGeneric {\n  display: flex;\n  align-items: center;\n  font-weight: 500;\n  font-size: 17px;\n  padding: 15px;\n  cursor: pointer;\n  min-width: 100px auto;\n  justify-content: center;\n}\n\n.buttonGenericCustom {\n  display: flex;\n  align-items: center;\n  font-weight: 500;\n  font-size: 17px;\n  padding: 10px 20px;\n  cursor: pointer;\n  width: 120px;\n  height: 50px;\n  border: solid 1px #007bc0;\n}\n\n.buttonCustom {\n  display: flex;\n  align-items: center;\n  font-weight: 500;\n  font-size: 17px;\n  padding: 10px 20px;\n  cursor: pointer;\n  height: 50px;\n  border: solid 1px #007bc0;\n  width: 100%;\n}\n\n.buttonCustom:hover {\n  background-color: #d1e4ff;\n  border: solid 1px #00629a;\n}\n\n.buttonGenericCustom span {\n  width: 100%;\n}\n\n.buttonFinish {\n  display: flex;\n  align-items: center;\n  font-weight: 500;\n  font-size: 17px;\n  padding: 15px 30px;\n  cursor: pointer;\n  margin-top: 20px;\n  background-color: #007bc0;\n  color: #ffffff;\n}\n\n.buttonFinish:hover {\n  background-color: #00629a;\n}\n\n.buttonFinish img {\n  margin-right: 10px;\n}\n\n.buttonReload {\n  display: flex;\n  align-items: center;\n  font-weight: 500;\n  font-size: 17px;\n  padding: 15px 30px;\n  cursor: pointer;\n  margin-top: 20px;\n  border: 1px solid #007bc0;\n}\n\n.buttonReload img {\n  margin-right: 10px;\n}\n\n.buttonReload:hover {\n  background-color: #dde5f0;\n}\n\n.buttonGeneric:disabled {\n  cursor: not-allowed;\n  background-color: #979ea4;\n}\n\n.imgIcone {\n  margin-right: 15px;\n}\n\n.buttonGeneric:disabled:hover {\n  background-color: #979ea4;\n}\n\n.buttonGeneric:hover {\n  background-color: #dde5f0;\n}\n\n.buttonGoOut {\n  display: flex;\n  align-items: center;\n  font-weight: 500;\n  font-size: 17px;\n  padding: 15px;\n  cursor: pointer;\n  width: 175px;\n  justify-content: center;\n  margin-bottom: 20px;\n  background-color: #007bc0;\n  color: #ffffff;\n}\n\n.buttonGoOut:hover {\n  background-color: #00629a;\n}\n\n.buttonGoOut:disabled {\n  cursor: not-allowed;\n  background-color: #d9d9d9;\n  color: #898989;\n}\n\nbutton.buttonGeneric.buttonHover:hover {\n  background: #00629a;\n}\n\n.buttonGenericCustom:hover {\n  background-color: #d1e4ff;\n}\n\n.buttonHeading {\n  display: flex;\n  align-items: center;\n  font-weight: 500;\n  font-size: 16px;\n  padding: 13px 15px;\n  cursor: pointer;\n  background-color: #007bc0;\n}\n\n.buttonHeading img {\n  padding-right: 6px;\n  width: 18px;\n  height: 18px;\n}\n\n.buttonHeading:hover {\n  background-color: #00629a;\n}\n\n.buttonBack {\n  display: flex;\n  align-items: center;\n  font-weight: 500;\n  font-size: 16px;\n  padding: 12px 15px;\n  cursor: pointer;\n  background-color: #fff;\n  border: 1px solid #007bc0;\n}\n\n.buttonBack img {\n  width: 11px;\n}\n\n.buttonBack:hover {\n  background-color: #d1e4ff;\n}\n\n.buttonDownload {\n  display: flex;\n  align-items: center;\n  font-weight: 500;\n  font-size: 16px;\n  padding: 13px 15px;\n  cursor: pointer;\n  background-color: #f9f9f9;\n}\n\n.buttonDownload:hover {\n  background-color: #d1e4ff;\n}\n\n.css-1v70q85-MuiDataGrid-root .MuiDataGrid-footerContainer {\n  background: #f9f9f9;\n}\n\n.css-1v70q85-MuiDataGrid-root {\n  border-width: 0px !important;\n  border-style: none !important;\n  border-color: transparent !important;\n  border-radius: 0px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
